<template>
    <div>
        <div class="mob-tip-text main-text">
            <span class="main-text-bold">Tip for mobile device users:</span> You
            need to press on the date to see the options
        </div>
        <FullCalendar ref="calendar" :options="calendarOptions">
            <template v-slot:eventContent="arg">
                <i
                    class="booked-event"
                    :class="{ active: arg.event.extendedProps.available }"
                >
                    {{ arg.event.title }}
                </i>

                <i
                    v-if="arg.event.extendedProps.tour_mode"
                    class="event-name__mobile d-none"
                    :class="{ active: arg.event.extendedProps.available }"
                >
                    <img
                        class="img-fluid tour-icon"
                        src="/images/icons/calendar/tour_mode.svg"
                        alt=""
                    />
                </i>

                <i
                    v-else
                    class="event-name__mobile d-none"
                    :class="{ active: arg.event.extendedProps.available }"
                >
                    <span class="custom-dot"></span>
                </i>
            </template>
        </FullCalendar>

        <div class="row pt-4 calendar-legend">
            <div class="legend-tab">
                <div class="px-4 row align-items-center">
                    <div
                        class="booked-event d-flex justify-content-start align-items-center"
                    >
                        <span class="px-2">Booked event</span>
                    </div>
                </div>

                <div class="px-4 row align-items-center">
                    <div
                        class="past-event d-flex justify-content-start align-items-center"
                    >
                        <span class="px-2">Past event</span>
                    </div>
                </div>

                <div class="px-2 row align-items-center">
                    <div
                        class="review-needed col-12 d-flex justify-content-start align-items-center"
                    >
                        <span class="px-2"> Rewiev needed</span>
                    </div>
                </div>
                <div class="px-4 row align-items-center">
                    <div
                        class="open-bid col-12 d-flex justify-content-start align-items-center"
                    >
                        <span class="px-2">Open bid</span>
                    </div>
                </div>
                <div class="px-4 row align-items-center">
                    <div
                        class="book-request col-12 d-flex justify-content-start align-items-center"
                    >
                        <span class="px-2">Booking request</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "@fullcalendar/core";
import Event from "./event";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import moment from "moment";
import Vue from "vue";

const axios = require("axios");
const Swal = require("sweetalert2");
export default {
    components: {
        FullCalendar,
        dayGridPlugin,
        interactionPlugin,
        bootstrapPlugin,
        Event,
    },
    props: {
        bandRequirements: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            calendarOptions: {
                plugins: [dayGridPlugin, interactionPlugin, bootstrapPlugin],
                headerToolbar: {
                    // left: 'dayGridMonth dayGridDay',
                    left: "title",
                    center: "today",
                    right: "prev,next",
                },
                /*titleFormat: {month: 'long'},*/
                initialView: "dayGridMonth",
                editable: true,
                selectable: true,
                selectMirror: true,
                moreLinkClick: "day",
                dayMaxEvents: true,
                weekends: true,
                nowIndicator: true,
                select: this.handleDateSelect,
                longPressDelay: 1,
                eventClick: this.handleEventClick,
                datesSet: this.datesRender,
                eventDrop: this.handleEventClick,
                eventResize: this.handleEventClick,
                eventDidMount: this.calendarHandleEventRender,
                contentHeight: "auto",
                // eventWillUnmount: null // event delete hook, for now we dont have logic to delete event in calendar, but in further add here function

                events: [
                    {
                        id: 3,
                        title: "Past event",
                        start: "2023-05-04",
                    },
                    {
                        id: 4,
                        title: "Elton John come here",
                        start: "2023-05-09",
                        classNames:['booked-event']
                    },
                     {
                        id: 5,
                        title: "Go go dance",
                        start: "2023-05-12",
                    },
                     {
                        id: 6,
                        title: "Need review",
                        start: "2023-05-19",
                    },
                    {
                        id: 7,
                        title: "dance revolution",
                        start: "2023-05-17",
                    },
                    {
                        id: 8,
                        title: "after party",
                        start: "2023-05-17",
                    },
                    {
                        id: 9,
                        title: "7 day binge",
                        start: "2023-05-17",
                    },
                ],
                textColor: 'yellow',
                eventOrder: "title,google",
            },
            startDate: null,
            endDate: null,
            newEvent: {},
            googleEvents: [],
        };
    },
    methods: {
        handleDateSelect(selectInfo) {
            console.log("handleDateSelect");
            let vm = this;
            let checkEvent = vm.getEventByDate(
                moment(selectInfo.start).format("YYYY-MM-DD")
            );
            if (checkEvent) {
                selectInfo.event = {};
                selectInfo.event._def = {};
                selectInfo.event.start = selectInfo.start;
                selectInfo.event.end = selectInfo.end;
                selectInfo.event._def.publicId = checkEvent.id;
                vm.handleEventClick(selectInfo);
                return;
            }
            let event = new Vue({
                ...Event,
                parent: this,
                propsData: {
                    event: {
                        date_from: moment(selectInfo.start).format(
                            "YYYY-MM-DD"
                        ),
                        date_to: moment(selectInfo.end)
                            .subtract(1, "d")
                            .format("YYYY-MM-DD"),
                        tour_mode: 0,
                        available: 1,
                        create: true,
                        price: 0.0,
                        radius: 1,
                        start_date_info: vm.startDate,
                        end_date_info: vm.endDate,
                        date_valid: null,
                    },
                    bandRequirements: vm.bandRequirements,
                },
            }).$mount();
            let swalOpen = Swal.fire({
                title: "Day info",
                heightAuto: false,
                html: event.$el,
                focusConfirm: false,
                showCancelButton: false,
                showConfirmButton: false,
                showCloseButton: true,
                didDestroy: () => event.$destroy(),
            });
            event.$on("close", () => swalOpen.close());
            event.$on("create", () => {
                swalOpen.close();
                vm.getEvents();
            });
        },
        handleEventClick(clickInfo) {
            if (
                clickInfo.event._def.extendedProps &&
                clickInfo.event._def.extendedProps.google
            ) {
                clickInfo.start = clickInfo.event._instance.range.start;
                clickInfo.end = clickInfo.event._instance.range.end;
                this.handleDateSelect(clickInfo);
                return;
            }
            let vm = this;
            let selectEvent = this.getEvent(clickInfo.event._def.publicId);
            selectEvent.date_from = moment(clickInfo.event.start).format(
                "YYYY-MM-DD"
            );
            selectEvent.date_to = moment(clickInfo.event.end)
                .subtract(1, "d")
                .format("YYYY-MM-DD");
            selectEvent.start_date_info = vm.startDate;
            selectEvent.end_date_info = vm.endDate;
            selectEvent.date_valid = null;
            let event = new Vue({
                ...Event,
                parent: this,
                propsData: {
                    event: selectEvent,
                    bandRequirements: vm.bandRequirements,
                },
            }).$mount();
            let swalOpenUpdate;
            Swal.fire({
                title: "Day info",
                heightAuto: false,
                html: event.$el,
                focusConfirm: false,
                showCancelButton: false,
                showConfirmButton: false,
                showCloseButton: true,
                didOpen: (sweet) => {
                    swalOpenUpdate = sweet;
                },
                didDestroy: () => event.$destroy(),
            }).then((res) => {
                if (res == "backdrop") {
                    vm.getEvents();
                }
            });
            event.$on("update", () => {
                $(swalOpenUpdate).find(".swal2-close").click();
                vm.getEvents();
            });
            event.$on("delete", () => {
                vm.getEvents();
            });
            event.$on("close", () => {
                $(swalOpenUpdate).find(".swal2-close").click();
                vm.getEvents();
            });
        },
        getEvents() {
            console.log(this.calendarOptions.events)
            // let vm = this;
            // axios
            //     .get("/events?start=" + this.startDate + "&end=" + this.endDate)
            //     .then((res) => {
            // vm.calendarOptions.events = res.data.events.data;
            // let id = 1;
            // res.data.google.data.forEach(function (element) {
            //     let start = moment(element.start);
            //     let end = moment(element.end);
            //     while (start < end) {
            //         let data = {
            //             id: id,
            //             user_id: element.user_id,
            //             title: element.title,
            //             google: element.google,
            //             editable: false,
            //         };
            //         ++id;
            //         data.start = moment(start)
            //             .startOf("day")
            //             .format("YYYY-MM-DD");
            //         let event = vm.getEventByDate(data.start);
            //         let googleEvent = vm.getGoogleEventByDate(
            //             data.start
            //         );
            //         if (!event && !googleEvent) {
            //             data.end = moment(start)
            //                 .endOf("day")
            //                 .format("YYYY-MM-DD");
            //             vm.googleEvents.push(data);
            //         }
            //         start = moment(start).add(1, "days");
            //     }
            // });
            // vm.calendarOptions.events =
            //     vm.calendarOptions.events.concat(vm.googleEvents);
            // });
        },
        datesRender(arg) {
            let start = moment(arg.view.activeStart)
                .utcOffset(0)
                .format("YYYY-MM-DD");
            let end = moment(arg.view.activeEnd)
                .utcOffset(0)
                .format("YYYY-MM-DD");
            if (start != this.startDate || end != this.endDate) {
                this.startDate = start;
                this.endDate = end;
                this.getEvents();
            }
        },
        getEvent(id) {
            return this.calendarOptions.events.filter(
                (event) => event.id == id
            )[0];
        },
        getEventByDate(date) {
            return this.calendarOptions.events.filter(
                (event) =>
                    !event.google &&
                    moment(event.date).format("YYYY-MM-DD") == date
            )[0];
        },
        getGoogleEventByDate(date) {
            return this.googleEvents.filter((event) => event.start == date)[0];
        },

        calendarHandleEventRender(view) {
            /** @type { HTMLElement } */
            const el = view.el;
            const eventsContainer = el.closest(".fc-daygrid-day-events");
            const fakeEvents = eventsContainer.querySelectorAll(
                ".js-fake-event-weekend"
            );
            fakeEvents.forEach((event) => event.remove());
        },
    },
};

function showPreloader() {
    $(".preloader").addClass("active");
}

function hidePreloader() {
    $(".preloader").removeClass("active");
}
</script>

<style lang="scss">
.legend-tab {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
}
.booked-event {
    background: #d7eb5a;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 4px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.05em;

    /* Primary neutrals/Dark grey 800 */

    color: #161616;
}
.past-event {
    background: #999999;
    border-radius: 4px;
    padding: 4px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.05em;

    /* Primary neutrals/Dark grey 800 */

    color: #161616;
}
.review-needed {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.05em;

    /* Primary neutrals/Dark grey 800 */

    color: #161616;
}
.review-needed::before {
    content: "\2605";
    font-size: 18px;
    color: #49306b;
}
.open-bid {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.05em;

    /* Primary neutrals/Dark grey 800 */

    color: #161616;
}
.open-bid::before {
    content: url(./Bid.jpg);
}
.book-request {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.05em;

    /* Primary neutrals/Dark grey 800 */

    color: #161616;
}
.book-request::before {
    content: url(./Bookings.jpg);
}
.calendar-legend .custom-dot {
    border-radius: 50%;
    height: 10px;
    width: 10px;
    display: flex !important;
    padding: 0;
}

.fc-event-main.fc-fake-event-main {
    color: #d7eb5a;
    text-align: start;
    font-size: var(--fc-small-font-size, 0.85em);
}

.wrapper-calendar {
    .fc {
        .fc-toolbar.fc-header-toolbar {
            margin-bottom: 20px;
            justify-content: flex-start;
            justify-content: flex-end;
            flex-direction: row-reverse;

            .fc-toolbar-chunk {
                display: flex;
                align-items: center;

                margin-right: 10px;

                .fc-today-button {
                    color: #49306b;
                    font-family: "Helvetica";
                    font-style: normal;
                    font-weight: 700;
                    font-size: 20px;
                    text-transform: capitalize;
                    line-height: 23px;
                    align-items: center;
                    padding: 8px 24px;
                    gap: 8px;
                    margin-left: 5px;
                    /* Primary neutrals/White 0 */

                    background: #ffffff;
                    cursor: pointer;
                    /* Primary/Purple 500 */

                    border: 2px solid #49306b;
                    border-radius: 24px;
                }

                .fc-today-button::before {
                    content: "\25EF";
                    font-weight: bold;
                    background: #49306b;
                    margin-right: 8px;
                    border-radius: 50%;
                    color: #49306b;
                }

                .fc-dayGridMonth-button,
                .fc-dayGridDay-button {
                    background-color: #fff;
                    // border: unset;
                    height: 40px;
                    width: 60px;
                    color: #180e27ff;
                    border-radius: 5px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .fc-toolbar-title {
                    font-family: "Helvetica";

                    font-style: normal;
                    font-weight: bold;
                    font-size: 24px;
                    line-height: 150%;
                    color: #161616;
                }

                .fc-button {
                    &:hover,
                    :active {
                        transform: scale(1.05) !important;
                        // box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.43) !important;
                    }
                }

                .fc-button-group {
                    .fc-button {
                        background-color: #fff;
                        border: unset;
                        width: 0px;
                        height: 40px;
                        //color: #BCBCBCFF;
                        // box-shadow: 0 15px 20px rgba(101, 100, 100, 0.15);
                        border-radius: 5px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #180e27ff;

                        // &:hover:active {
                        //     // transform: scale(1.05) !important;
                        //     // box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.43) !important;
                        // }

                        &:first-child {
                            margin-right: 20px;
                        }
                    }

                    .fc-icon {
                        vertical-align: middle;
                        font-size: 2.5em;
                    }
                }
            }
        }
    }

    .fc .fc-scrollgrid-section-liquid > td {
        border: #f2f2f2;
    }

    .fc-scrollgrid {
        border-radius: 8px 8px 0 0;
        border: 1px solid #f2f2f2;

        .fc-col-header {
            thead {
                tr {
                    .fc-col-header-cell {
                        .fc-scrollgrid-sync-inner {
                            padding: 30px;
                            background: #f2f2f2;

                            .fc-col-header-cell-cushion {
                                font-family: "Inter";
                                font-style: normal;
                                font-weight: 700;
                                font-size: 19.1366px;
                                line-height: 23px;
                                text-align: center;
                                letter-spacing: 0.1em;
                                text-decoration: none;
                                color: #2d3648;
                            }
                        }
                    }
                }
            }
        }

        thead {
            th {
                border: none;
            }

            .fc-scroller-harness {
                border-radius: 8px 8px 0 0;
            }
        }

        tbody {
            .fc-day-past {
                height: 100px;
            }

            .fc-day-future {
                height: 100px;
            }

            tr {
                .fc-daygrid-day {
                    .fc-daygrid-day-frame {
                        padding-top: 0px;

                        .fc-daygrid-day-top {
                            padding-right: 15px;
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-end;

                            .fc-daygrid-day-number {
                                font-family: "Montserrat";
                                font-style: normal;
                                font-weight: 700;
                                font-size: 14px;
                                line-height: 150%;
                                /* identical to box height, or 21px */
                                text-decoration: none;
                                text-align: center;
                                letter-spacing: 0.1em;
                                text-transform: uppercase;

                                /* Neutrals/Grey 600 */

                                color: #6e6e6e;
                            }
                        }

                        .fc-daygrid-day-events {
                            padding-right: 30px;

                            .fc-daygrid-event {
                                background: transparent;
                                border: none;

                                .fc-event-main {
                                    text-align: start;

                                    .active {
                                        font-weight: normal;


                                        .custom-dot {
                                            background-color: #5fbf3d;
                                        }
                                    }
                                }
                            }
                        }

                        .custom-dot {
                            background-color: #d7eb5a;
                            border-radius: 50%;
                            height: 6px;
                            width: 6px;
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
}

.swal2-container {
    .swal2-popup {
        border-radius: 10px;
    }

    .swal2-close {
        color: #161616;
    }

    .swal2-title {
        font-weight: bold;
        font-size: 1.5em;
        line-height: 27px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #161616;
    }

    .form-check-label {
        font-weight: bold;
        font-size: 1.125em;
        line-height: 27px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #161616;
        padding-bottom: 15px;
    }

    .swal2-html-container {
        margin: 0;
        padding: 30px 30px 10px 30px;

        .row {
            padding: 0;

            div {
                text-align: left;
            }

            .mx-datepicker-range {
                width: 100%;
            }

            label {
                font-weight: bold;
                font-size: 1.125em;
                line-height: 27px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #161616;
            }

            .form-check {
                margin-bottom: 0;

                &.form-radio {
                    label {
                        font-weight: normal;
                        font-size: 1em;
                        line-height: 27px;
                        letter-spacing: 0.1em;
                        color: #161616;
                        text-transform: lowercase;
                    }

                    .form-check-input {
                        height: 18px;

                        &:checked[type="radio"] {
                            background-color: white;
                            background-image: url("/images/calendar-check.png");
                            background-size: 12px;
                            background-position: center;
                        }

                        &:focus {
                            box-shadow: unset;
                        }
                    }
                }

                &.form-switch {
                    display: grid;

                    .form-check-tour {
                        display: flex;
                        align-items: center;
                        margin-top: 0 !important;

                        .form-check-input {
                            margin-top: 0;
                            margin-left: 0;
                            float: unset;
                            height: 34px;
                            background-position: right 84% bottom 55%;
                            background-size: 22px;
                            width: 64px;

                            &:checked {
                                background-position: left 85% bottom 55% !important;
                            }

                            &:focus {
                                outline: 0;
                                background-color: unset;
                                border-color: unset;
                                box-shadow: unset;
                            }
                        }

                        span {
                            font-weight: bold;
                            font-size: 1em;
                            line-height: 27px;
                            color: #161616;
                            opacity: 0.3;

                            &:first-child {
                                padding-right: 15px;
                            }

                            &:last-child {
                                padding-left: 15px;
                            }
                        }
                    }
                }
            }

            .mx-datepicker input {
                background-color: unset;

                &:hover {
                    border-color: #49306b;
                }
            }

            .form-control {
                background-color: unset;
            }

            .form-control:focus {
                color: unset;
                background-color: unset;
                border-color: unset;
                outline: 0;
                box-shadow: unset;
            }

            .form-control:hover {
                border-color: #49306b;
            }

            .form-switch {
                padding-left: 0;
            }
        }
    }

    .custom-modal-btn-close {
        font-weight: bold;
        background: #b8b8b8;
        border-radius: 100px;
        color: white;
        padding: 12px 40px;

        &:hover {
            box-shadow: unset;
        }
    }

    .custom-modal-btn-confirm {
        font-weight: bold;
        padding: 12px 40px;

        &:hover {
            box-shadow: unset;
        }
    }

    .swal2-close:focus {
        outline: 0;
        box-shadow: unset;
    }
}

@media (min-width: 1441px) and (max-width: 1500px) {
    .wrapper-calendar
        .fc-scrollgrid
        tbody
        tr
        .fc-daygrid-day
        .fc-daygrid-day-frame {
        padding-top: 40px;
    }
}

@media (min-width: 1264px) and (max-width: 1440px) {
    .wrapper-calendar
        .fc-scrollgrid
        tbody
        tr
        .fc-daygrid-day
        .fc-daygrid-day-frame {
        padding-top: 30px;
    }
}

@media (max-width: 1024px) {
    .wrapper-calendar
        .fc-scrollgrid
        tbody
        tr
        .fc-daygrid-day
        .fc-daygrid-day-frame
        .fc-daygrid-day-top {
        padding-right: 4px;
    }

    .wrapper-calendar
        .fc-scrollgrid
        tbody
        tr
        .fc-daygrid-day
        .fc-daygrid-day-frame
        .fc-daygrid-day-events {
        padding-right: 4px;
    }

    .wrapper-calendar .fc-scrollgrid tbody .fc-day-past {
        height: unset;
    }

    .wrapper-calendar .fc-scrollgrid tbody .fc-day-future {
        height: unset;
    }

    .wrapper-calendar
        .fc-scrollgrid
        tbody
        tr
        .fc-daygrid-day
        .fc-daygrid-day-frame {
        padding-top: 0;
    }
}

@media (max-width: 767px) {
    .wrapper-calendar
        .fc
        .fc-scrollgrid
        thead
        .fc-col-header
        thead
        tr
        .fc-col-header-cell
        .fc-scrollgrid-sync-inner {
        padding: 10px;
    }

    .wrapper-calendar
        .fc-scrollgrid
        .fc-col-header
        thead
        tr
        .fc-col-header-cell
        .fc-scrollgrid-sync-inner
        .fc-col-header-cell-cushion {
        font-size: 14px;
    }

    .wrapper-calendar
        .fc
        .fc-toolbar.fc-header-toolbar
        .fc-toolbar-chunk
        .fc-button-group
        .fc-icon {
        font-size: 1.5em;
    }

    .wrapper-calendar
        .fc
        .fc-toolbar.fc-header-toolbar
        .fc-toolbar-chunk
        .fc-button-group
        .fc-button {
        width: 25px;
        height: 40px;
    }
}

@media (max-width: 420px) {
    .swal2-container .swal2-html-container .row .mx-datepicker-range {
        padding-bottom: 30px;
    }
}

@media (min-width: 600px) {
    .calendar-legend {
        display: flex;
    }

    .mob-tip-text {
        display: none;
    }
}

// calendar mobile small redesign
@media (min-width: 360px) and (max-width: 600px) {
    .fc-daygrid-day-events {
        padding: 0 !important;
        margin-bottom: 0 !important;
    }

    // temp, later se-structure

    .fc-daygrid-day-top {
        padding: 0 !important;
        padding-top: 1rem !important;
    }

    .fc-daygrid-day-number {
        width: 100%;
        text-align: center;
    }

    .wrapper-calendar {
        .fc-toolbar.fc-header-toolbar {
            margin-bottom: 30px !important;

            & > :last-child {
                margin: 0 auto;
            }
        }

        .fc-daygrid {
            //border-radius: 20px 20px 0 0;
            border-radius: 20px;

            .fc-scrollgrid-section {
                td {
                    border-radius: 0 0 20px 20px;
                }

                th,
                .fc-scroller-harness {
                    border-radius: 20px 20px 0 0;
                }

                .fc-col-header-cell {
                    padding-left: 0;
                    padding-right: 0;

                    .fc-scrollgrid-sync-inner {
                        padding: 0 !important;

                        .fc-col-header-cell-cushion {
                            padding-top: 0.7rem;
                            padding-bottom: 0.7rem;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            width: 18px;
                            letter-spacing: 8px !important;
                        }
                    }
                }

                .fc-scroller-harness {
                    box-shadow: 0px 15px 20px rgba(101, 100, 100, 0.05);
                }
            }

            .fc-daygrid-day {
                height: 90px !important;
            }
        }

        .event-name__desktop {
            display: none;
        }

        .event-name__mobile {
            display: block !important;
            text-align: center;
        }
    }
}
</style>
